import React, {Component} from 'react';
import OrganisationChartPopUp from "../../popup/OrganisationChartPopUp.component";
import Select from 'components/common/select/Select.component';
import { Button, ButtonType } from 'components/common/Button.component';
import { FormField } from 'components/common/FormField.component';
import * as reduxSelectors from "../../store/application.reducers";
import {connect} from "react-redux";
import {getOrgChartTreeNodes} from "../../organisationChart/organisationChart.action";
import { MODAL_ACTIONS } from "utils/constants";
import { launchDarkly } from "utils/launchDarkly";
import { useModalContext } from "components/modals/ModalContext";

export class SimulatorOrganisationChart extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            search: ''
        };

        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
        this.onConfirmModal = this.onConfirmModal.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.onSelectInputChange = this.onSelectInputChange.bind(this);

        this.fieldRef = null;
    }


    componentDidMount() {
        this.props.getOrgChartTreeNodes(new Date(),null,this.props.companyId);
    }

    useNewModals() {
        return this.props.useNewModals && !!this.props.toggleModal;
    }

    showModal() {
        if (this.useNewModals()) {
            this.props.toggleModal(MODAL_ACTIONS.ORGANISATION_CHART, {
                handleAction: this.onConfirmModal,
                closeCallback: this.hideModal,
            });
            return;
        }
        this.setState({
            showModal: true
        });
    }

    hideModal() {
        this.setState({
            showModal: false
        });
    }

    onConfirmModal(node) {
        this.setState({
            showModal: false
        });

        if (this.useNewModals()) {
            this.props.toggleModal(null);
        }

        if (!node) {
            return;
        }

        this.props.onChange({
            value: node.item.organizationUnitId,
            label: `${node.item.organizationUnitCode} - ${node.item.name}`
        });
    }

    onSelectChange(option) {
        this.props.onChange(option || null);
    }

    onSelectInputChange(value) {
        this.setState({
            search: value
        });
    }

    render() {
        const options = this.state.search !== '' ? this.props.selectEntries : [];
        const selected = this.props.orgChartId;
        return (
            <div className="form-group organization-chart-input">
                { this.state.showModal && !this.useNewModals() &&
                    <OrganisationChartPopUp translate={this.props.translate}
                                            handleAction={this.onConfirmModal}
                                            closeCallback={this.hideModal} /> }

                <FormField
                    id="simulator-organisation-unit"
                    label={this.props.translate("workflowDetails.simulator.organisationUnit")}
                >
                    <div className="form-group d-flex align-items-center gap-2">
                        <div className="flex-grow-1">
                            <Select
                                options={options}
                                ref={(field) => { this.props.onRefInit(field) }}
                                value={selected}
                                inputValue={this.state.search}
                                isClearable={true}
                                isSearchable={true}
                                onChange={this.onSelectChange}
                                onInputChange={this.onSelectInputChange}
                                name="department"
                                translate={this.props.translate}
                            />
                        </div>
                        <Button
                            type={ButtonType.SECONDARY}
                            text={this.props.translate("workflowDetails.simulator.select")}
                            onClick={this.showModal}
                            extraClassName="open-modal-button"
                            ariaLabel={this.props.translate("workflowDetails.simulator.openOrganisationChart")}
                            title={this.props.translate("workflowDetails.simulator.openOrganisationChart")}
                        />
                    </div>
                </FormField>
            </div>
        );
    }
}


const mapStateToProps = function (store) {
    const orgChartTree = reduxSelectors.getOrgChartTree(store);

    return {
        orgChartTree,
        companyId: reduxSelectors.getUsersCurrentContextId(store),
        selectEntries: orgChartTree && orgChartTree.rows
            .map((node) => ({
                label: `${node.item.organizationUnitCode} - ${node.item.name}`,
                value: node.item.organizationUnitId
            })),
    };
};

const Connected = connect(mapStateToProps, {
    getOrgChartTreeNodes,
})(SimulatorOrganisationChart);

const SimulatorOrganisationChartWithModal = (props) => {
    const useNewModals = launchDarkly.companyClient?.variation("use-new-modals", false);
    const modalContext = useModalContext();
    const { toggleModal } = modalContext || {};
    return <Connected {...props} useNewModals={useNewModals} toggleModal={toggleModal} />;
};

export default SimulatorOrganisationChartWithModal;
